import React from "react";

export default (props) => {
  const { text, boldfirst} = props;
  console.log(props );
  const cls = "paragraph " + (boldfirst ? " paragraph--boldfirst " : "");
  return (
    <div className={cls}>
      {text
        ? text.split("\n\n").map((s, i) => (
            <p key={i}>
              {s.split("\n").map((b, ii) => (
                <span key={ii}>
                  {b}
                  <br />
                </span>
              ))}
            </p>
          ))
        : null}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Formaters/Paragraphs.jsx